import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { UserProfileElementWrapperComponent } from "./components/user-profile-element-wrapper/user-profile-element-wrapper.component";
import {} from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
//import { NgxSpinnerModule } from "ngx-spinner";
import { UserProfileRoutingModule } from "./user-profile-routing.module";
import { UserProfileHeaderComponent } from "./components/user-profile-header/user-profile-header.component";

@NgModule({
    imports: [
        RouterModule,
        // HttpClientModule,
        // FormsModule,
        // CommonModule,
        // NgxSpinnerModule,
        UserProfileRoutingModule,
        UserProfileElementWrapperComponent,
        UserProfileHeaderComponent
    ],
    exports: [
        UserProfileHeaderComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserProfileModule { }
